import React from "react";

import { bem } from "@react-md/utils";
import { BreadcrumbProps as AntdBreadcrumbProps } from "antd";
import AntdBreadcrumb from "antd/es/breadcrumb";
import cn from "classnames";

const block = bem("mmc-breadcrumb");

export interface BreadcrumbProps extends AntdBreadcrumbProps {
  className?: string;
}

const Breadcrumb = ({ children, className, ...restProps }: BreadcrumbProps) => {
  return (
    <AntdBreadcrumb className={cn(block(), className)} {...restProps}>
      {children}
    </AntdBreadcrumb>
  );
};

export default Breadcrumb;
